import { Model } from './model';

export class ExecutionModel implements Model {
  suite_id: string;
  hub_ip: string;
  port: number;
  default_pause: string;
  send_mail: boolean;
  browser: string[];
  resolution: string;
  screenshot_required: boolean;
  default_hub: boolean;
  local_execution: boolean;
  execution_machine: string;
  is_implicit_default_pause: boolean;

  execution_type?: string;
  mobile_apk_path?: string;
  mobile_ipa_path?: string;
  emulators?: { [key: string]: string }[];
  aiIntelligence?: string;
}